'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _icon = require('../icon/icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function SimpleNavItem(_ref) {
  var children = _ref.children,
      icon = _ref.icon,
      iconSize = _ref.iconSize,
      active = _ref.active,
      props = _objectWithoutProperties(_ref, ['children', 'icon', 'iconSize', 'active']);

  var classes = (0, _classnames2.default)('simple-navigation__item', active && 'simple-navigation__item--active');

  return _react2.default.createElement(
    'li',
    _extends({ className: classes }, props),
    icon && _react2.default.createElement(_icon2.default, { name: icon, size: iconSize, className: 'simple-navigation__icon' }),
    children
  );
}

SimpleNavItem.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  icon: _propTypes2.default.string,
  iconSize: _propTypes2.default.string,
  active: _propTypes2.default.bool
};

SimpleNavItem.defaultProps = {
  iconSize: '16'
};

exports.default = SimpleNavItem;